// IE 2026 10 07 / ODOO-343741: ширины колонок xlsx-экспорта печати (AttrGridGroup.mvt_exportXlsx).
// Базовые колонки листа = объединение границ колонок всех секций, поэтому ширины КАЖДОЙ секции должны
// быть теми же, что при отрисовке. Раньше ширины брались только из ОТРИСОВАННЫХ гридов секций
// (список отфильтрованных flex'ов): неотрисованная секция (ниже экрана) получала по 80 px на колонку —
// лишние границы, месяцы съезжали (ieSN_001: месяцы с F вместо D), а при неотрисованной СРЕДНЕЙ секции
// индексы сдвигались и ширины уезжали к соседям.
// Теперь ширины сопоставляются секции по её ИНДЕКСУ; у неотрисованной секции — ширина из данных секции
// так же, как её посчитал бы грид (dataW), затем ширина той же колонки отрисованной секции, затем 80.

export const MVT_XLSX_FALLBACK_W = 80

// used:  [N] — число используемых колонок секции (col_1..col_N)
// gridW: [{ 'col_c': px } | null] — по ИНДЕКСУ секции: ширины колонок отрисованного грида; null — грид не отрисован
// dataW: (i, binding) => px | null — ширина колонки секции i из данных (как при отрисовке), для неотрисованной секции
// → [[0, x1, x2, ...]] — накопленные границы колонок каждой секции, px
export function mvtXlsx_sectionAccs(used, gridW, dataW = null, fallback = MVT_XLSX_FALLBACK_W) {
    const borrow = (b) => {
        for (const g of gridW || []) if (g && g[b]) return g[b]
        return null
    }
    return used.map((n, i) => {
        const g = gridW?.[i] || null
        const wOf = (c) => {
            const b = 'col_' + c
            let w
            if (g) w = g[b] || fallback                     // отрисована — как раньше
            else w = (dataW && dataW(i, b)) || borrow(b) || fallback
            return Math.max(8, Math.round(w))
        }
        const acc = [0]
        for (let c = 1; c <= n; c++) acc.push(acc[acc.length - 1] + wOf(c))
        return acc
    })
}

// ширина колонки грида из описания колонки — разбор как в AttrGrid (сборка колонок):
// число / числовая строка → px; строка с 'auto' или пусто → 'auto' (автоширина по данным);
// прочие строки ('*', '2*') → null (размер зависит от ширины грида — из данных не вывести)
export function mvtXlsx_attrWidth(width) {
    if (typeof width === 'number') return width || 'auto'
    if (typeof width === 'string') {
        if (!isNaN(Number(width))) return Number(width) || 'auto'
        if (width.toLowerCase().includes('auto')) return 'auto'
        return width ? null : 'auto'
    }
    return 'auto'
}
